export const AUTH_ROUTES = {
  home: '/',
  login: '/auth/login',
  otpPage: '/2-way/verification',
  resetPassword: '/auth/password-reset',
  updatePassword: '/auth/password-update',
  newUserRegistration: '/auth/new-user',
  qrCodeAndPasswordSet: '/auth/new-user/register',
  notFoundPage: '/error404',
};
